import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { prependPathWithParams } from '@dhl/utils'
import { AdminUsersRoutes, adminUsersLinks } from '~/modules/adminusers/view'
import { billingUnitLinks, BillingunitRoutes } from '~/modules/billingunits/view'
import { checkEmailLinks, CheckEmailsRoutes } from '~/modules/checkemails/view'

import { dashboardLinks, DashboardRoutes } from '~/modules/dashboard/view'
import { integratorsLinks, IntegratorsRoutes } from '~/modules/integrators/view'
import { labelLinks, LabelRoutes } from '~/modules/label/view'
import { dhlExtraLinks, DhlExtraRoutes } from '~/modules/dhl-extra/view'
import { NotFoundPage } from '~/modules/navigation/views'
import { organisationLinks, OrganisationRoutes } from '~/modules/organisations/view'
import { profileLinks, ProfileRoutes } from '~/modules/profile/view'
import { promocodesLinks, PromocodesRoutes } from '~/modules/promocodes/view'
import { reportsLinks, ReportsRoutes } from '~/modules/reports/view'
import { reprintLinks, ReprintRoutes } from '~/modules/reprint/view'
import { ReturnHubRoutes, returnHubsLinks } from '~/modules/returnhubsccc/view'
import { servicePointLinks, ServicePointRoutes } from '~/modules/servicepoints/view'
import { servicePointVendorLinks, ServicePointVendorRoutes } from '~/modules/servicepointvendors/view'
import { terminalsLinks, TerminalsRoutes } from '~/modules/terminals/view'
import { pppLinks, PppRoutes } from '~/modules/ppp/view'
import { UserRoutes, usersLinks } from '~/modules/users/view'
import { apiLogin } from './api'

const BASE_PATH = {
  DASHBOARD: 'dashboard',
  ADMIN_USERS: 'adminusers',
  USERS: 'users',
  REPORTS: 'reports',
  TERMINALS: 'terminals',
  INTEGRATOR: 'integrators',
  REPRINT: 'reprint',
  LABEL: 'label',
  PROMOCODES: 'promocodes',
  CHECK_EMAILS: 'checkemails',
  PROFILE: 'profile',
  ORGANISATION: 'organisations',
  SERVICEPOINTS: 'servicepoints',
  SERVICEPOINT_VENDORS: 'servicepoint-vendors',
  BILLINGUNITS: 'billingunits',
  RETURNHUBS_CCC: 'returnhubsccc',
  DHL_EXTRA: 'dhl-extra',
  PPP: 'ppp',
}

export const PATH = {
  OVERVIEW: '/',
  DETAILS: 'details',
  ADD: 'add',
  EDIT: 'edit',
}

export const EXTERNAL_PATHS = {
  ACCOUNT: 'account',
}

const ExternalRoute = ({ path }: { path: string }) => {
  window.location.replace(path)
  return null
}

export const AppRoutes = () => {
  useEffect(() => {
    apiLogin()
  }, [])

  return (
    <Routes>
      <Route path={`${BASE_PATH.ADMIN_USERS}/*`} element={<AdminUsersRoutes />} />
      <Route path={`${BASE_PATH.USERS}/*`} element={<UserRoutes />} />
      <Route path={`${BASE_PATH.REPORTS}/*`} element={<ReportsRoutes />} />
      <Route path={`${BASE_PATH.TERMINALS}/*`} element={<TerminalsRoutes />} />
      <Route path={`${BASE_PATH.INTEGRATOR}/*`} element={<IntegratorsRoutes />} />
      <Route path={`${BASE_PATH.REPRINT}/*`} element={<ReprintRoutes />} />
      <Route path={`${BASE_PATH.LABEL}/*`} element={<LabelRoutes />} />
      <Route path={`${BASE_PATH.PROMOCODES}/*`} element={<PromocodesRoutes />} />
      <Route path={`${BASE_PATH.CHECK_EMAILS}/*`} element={<CheckEmailsRoutes />} />
      <Route path={`${BASE_PATH.PROFILE}/*`} element={<ProfileRoutes />} />
      <Route path={`${BASE_PATH.ORGANISATION}/*`} element={<OrganisationRoutes />} />
      <Route path={`${BASE_PATH.SERVICEPOINTS}/*`} element={<ServicePointRoutes />} />
      <Route path={`${BASE_PATH.SERVICEPOINT_VENDORS}/*`} element={<ServicePointVendorRoutes />} />
      <Route path={`${BASE_PATH.BILLINGUNITS}/*`} element={<BillingunitRoutes />} />
      <Route path={`${BASE_PATH.RETURNHUBS_CCC}/*`} element={<ReturnHubRoutes />} />
      <Route path={`${BASE_PATH.DHL_EXTRA}/*`} element={<DhlExtraRoutes />} />
      <Route path={`${BASE_PATH.PPP}/*`} element={<PppRoutes />} />
      <Route path={BASE_PATH.DASHBOARD} element={<DashboardRoutes />} />
      <Route path={`/`} element={<DashboardRoutes />} />

      {Object.values(EXTERNAL_PATHS).map((path) => (
        <Route key={path} path={`/${path}`} element={<ExternalRoute path={`/${path}`} />} />
      ))}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

const externalLinks = {
  signInLink: () => `/${EXTERNAL_PATHS.ACCOUNT}/sign-in?referrer=admin`,
}

export const links = {
  ...prependPathWithParams(() => BASE_PATH.DASHBOARD, dashboardLinks),
  ...prependPathWithParams(() => BASE_PATH.ADMIN_USERS, adminUsersLinks),
  ...prependPathWithParams(() => BASE_PATH.USERS, usersLinks),
  ...prependPathWithParams(() => BASE_PATH.REPORTS, reportsLinks),
  ...prependPathWithParams(() => BASE_PATH.TERMINALS, terminalsLinks),
  ...prependPathWithParams(() => BASE_PATH.INTEGRATOR, integratorsLinks),
  ...prependPathWithParams(() => BASE_PATH.REPRINT, reprintLinks),
  ...prependPathWithParams(() => BASE_PATH.LABEL, labelLinks),
  ...prependPathWithParams(() => BASE_PATH.PROMOCODES, promocodesLinks),
  ...prependPathWithParams(() => BASE_PATH.CHECK_EMAILS, checkEmailLinks),
  ...prependPathWithParams(() => BASE_PATH.PROFILE, profileLinks),
  ...prependPathWithParams(() => BASE_PATH.ORGANISATION, organisationLinks),
  ...prependPathWithParams(() => BASE_PATH.SERVICEPOINTS, servicePointLinks),
  ...prependPathWithParams(() => BASE_PATH.SERVICEPOINT_VENDORS, servicePointVendorLinks),
  ...prependPathWithParams(() => BASE_PATH.RETURNHUBS_CCC, returnHubsLinks),
  ...prependPathWithParams(() => BASE_PATH.BILLINGUNITS, billingUnitLinks),
  ...prependPathWithParams(() => BASE_PATH.DHL_EXTRA, dhlExtraLinks),
  ...prependPathWithParams(() => BASE_PATH.PPP, pppLinks),
  ...externalLinks,
}
